
import { defineComponent } from 'vue'
import { AlButton } from '~/components/ui'

export default defineComponent({
  name: 'ProviderCard',
  components: { AlButton },
  props: {
    title: {
      type: String,
      required: true,
    },
    logo: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
  },
})
